import { Breadcrumbs } from "@mantine/core";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import RenderText from "../ui/render-text";
import classes from "./breadcrumb.module.css";

type Props = {
  data: { label: string; to?: string }[];
};

export function Breadcrumb({ data }: Props) {
  return (
    <Breadcrumbs separator="/">
      {data.map((item, index) => (
        <Fragment key={index}>
          {item.to ? (
            <Link to={item.to} className={classes.link}>
              <RenderText text={item.label} useHover />
            </Link>
          ) : (
            <RenderText text={item.label} />
          )}
        </Fragment>
      ))}
    </Breadcrumbs>
  );
}
